<template>
  <div class="userList">
    <div class="search_wrap" id="search">
      <el-form :model="queryParam" ref="form" label-width="100px" :inline="true" size="mini">
        <el-form-item label="用户名">
          <el-input v-model="queryParam.userName" placeholder="请输入" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="queryParam.phone" placeholder="请输入" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="街道">
          <el-select
            v-model="queryParam.street"
            clearable
            placeholder="请选择"
            style="width: 200px"
            @change="streetchange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, key) in streetList"
              :key="key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="社区">
          <el-select
            :disabled="queryParam.street.length == 0"
            v-model="queryParam.community"
            clearable
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethodcommunity"
            style="width: 200px"
          >
            <el-option
              v-for="item in communityList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            unlink-panels
            :clearable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="bedata"
            @change="timechange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <!-- <el-button type="primary" @click="exportData">导出</el-button> -->
          <div class="exportSelectBox">
            <el-select value="更多" size="mini" @change="selectExport">
              <el-option
                value="/user/statistical/userInfoList/export"
                label="用户列表导出"
              ></el-option>
              <el-option
                value="/user/statistical/epgDistributionExport"
                label="环保金分布占比导出"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-button type="primary" size="small" @click="addUser('add')">新增用户</el-button>
    </div>
    <div class="table_div">
      <el-table
        :data="userDataList"
        border
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        :default-expand-all="false"
        style="width: 100%"
        :max-height="maxHeight"
      >
        <el-table-column prop="nickname" label="昵称" fixed width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="userNo" label="用户编号" width="150" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column prop="avatar" label="头像">
          <template slot-scope="scope">
            <img
              :src="
                scope.row.avatar ||
                'https://waliminiapp.oss-cn-beijing.aliyuncs.com/wali/2733a4h507.png'
              "
              style="width: 30px; height: 30px"
              alt="#"
            />
          </template>
        </el-table-column>-->
        <!-- <el-table-column
          prop="brithday"
          label="生日"
          width="120"
          :show-overflow-tooltip="true"
        ></el-table-column>-->
        <el-table-column
          prop="totalAmount"
          label="环保金总金额"
          width="120"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column prop="money" label="环保金可用余额" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column
          prop="frozenAmount"
          label="环保金冻结金额"
          width="120"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="refoundAmount"
          label="环保金退款金额"
          width="120"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column prop="street" label="街道" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="community" label="社区" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="address" label="地址" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="orderNum" label="下单次数" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="150" :show-overflow-tooltip="true"></el-table-column>
        <!-- <el-table-column
          prop="updateTime"
          label="更新时间"
          width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>-->
        <el-table-column width="240px" label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="addUser('edit', scope.row)">编辑</el-button>
            <el-button size="mini" @click="contract(scope.row)">约单</el-button>
            <el-button size="mini" @click="orderQuert(scope.row)">订单信息</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <el-drawer :title="title" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
      <userAddEdit @saveSubmit="saveSubmit" :userData="userData" :isQuery="isQuery" v-if="drawer"></userAddEdit>
    </el-drawer>
    <el-drawer title="约单" :visible.sync="dialogVisible" direction="rtl" :before-close="handleClose">
      <contract @saveSubmit="saveSubmitcontract" :userData="userData" v-if="dialogVisible"></contract>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import userAddEdit from './component/userAddEdit.vue'
import contract from './component/contract.vue'
import { publicMixin } from '@/mixins/publicMixin'
import { listMixin } from "@/mixins/listMixin";
import {
  userInfoList,
  addressstreetlist,
  addresscommunitylist,
  helpBookingOrder,
  statisticaladdUser,
  statisticalupdateUser,
} from '@/api/management'
export default {
  name: 'userList',
  components: { userAddEdit, contract },
  mixins: [publicMixin, listMixin],
  data () {
    return {
      where: '',
      maxHeight: 0,
      title: '',
      isQuery: false,
      drawer: false,
      dialogVisible: false,
      recycleData: {},
      userData: {},
      streetList: [],
      communityList: [],
      wlStreetId: '',
      name: '',
      bedata: '',
      queryParam: {
        userName: '',
        community: '',
        createBeginTime: '',
        createEndTime: '',
        // beginTime: "",
        // endTime: "",
        street: '',
      },
      userDataList: [],
    }
  },
  mounted () {
    let div = document.getElementById('search')
    let h = div.offsetHeight
    let screenH = document.body.clientHeight
    this.$nextTick(() => {
      this.maxHeight = screenH - h - 250
    })
  },
  methods: {
    loadData(arg) {},
    selectExport(e) {
      if (
        !this.queryParam.createBeginTime &&
        !this.queryParam.createEndTime &&
        e === "/user/statistical/userInfoList/export"
      ) return this.$message.warning("请选择创建时间后导出");
      let newName = "";
      if (e === "/user/statistical/userInfoList/export") newName = "用户列表导出";
      if (e === "/user/statistical/epgDistributionExport") newName = "环保金分布占比导出";
      this.handleExportXls(newName, e);
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },
    orderQuert (row) {
      this.$router.push({
        path: '/userRecycleList',
        query: { wlUserId: row.userId },
      })
    },
    saveSubmitcontract (params) {
      helpBookingOrder(params).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '约单成功!',
          })
          this.dialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    saveSubmit (params) {
      let obj = JSON.parse(JSON.stringify(params))
      if (this.where == 'add') {
        delete obj.street
        delete obj.userId
        statisticaladdUser(obj).then((res) => {
          if (res.code == 200) {
            if (res.data) {
              this.$message.success('操作成功')
              this.drawer = false
              this.currentPage = 1
              this.getDataList()
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        statisticalupdateUser(obj).then((res) => {
          if (res.code == 200) {
            if (res.data) {
              this.$message.success('操作成功')
              this.drawer = false
              this.currentPage = 1
              this.getDataList()
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    contract (row) {
      this.dialogVisible = true
      this.userData = row
    },
    addUser (where, row) {
      this.drawer = true
      this.isQuery = false
      this.where = where
      if (where == 'add') {
        this.title = '新增用户'
      } else {
        this.title = '编辑用户'
        if (where == 'query') {
          this.title = '用户详情'
          this.isQuery = true
        }
        this.userData = row
      }
    },
    searchQuery () {
      this.currentPage = 1
      this.getDataList()
    },
    remoteMethodcommunity (query) {
      this.name = query
      this.getaddresscommunitylist(this.name, this.wlStreetId)
    },
    streetchange (val) {
      this.queryParam.community = ''
      this.wlStreetId = val
      this.getaddresscommunitylist(this.name, [this.wlStreetId])
    },
    getaddresscommunitylist (name, wlStreetId) {
      if (wlStreetId != 0) {
        addresscommunitylist({
          name: name,
          wlStreetId: wlStreetId,
        }).then((res) => {
          if (res.code == 200) {
            this.communityList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    getaddressstreetlist () {
      addressstreetlist({}).then((res) => {
        if (res.code == 200) {
          this.streetList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getDataList () {
      let obj = this.queryParam
      obj.pageNo = this.currentPage
      obj.pageSize = this.PageSize
      userInfoList(obj).then((res) => {
        if (res.code == 200) {
          this.totalCount = res.data.total
          this.currentPage = res.data.current
          this.PageSize = res.data.size
          this.userDataList = res.data.records
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    exportData () {
      let exportXlsUrl = 'user/statistical/userInfoList/export'
      let fileName = '用户数据'
      let obj = {}
      obj = JSON.parse(JSON.stringify(this.queryParam))
      obj.pageNo = this.currentPage
      obj.pageSize = this.PageSize
      this.export(exportXlsUrl, obj, fileName)
    },
    timechange (val) {
      this.queryParam.createBeginTime = val[0]
      this.queryParam.createEndTime = val[1]
    },
  },
  created () {
    // var myDate = new Date();
    // // 获取 特定日期 之前的 第七天
    // let tmpArr = [];
    // tmpArr.push(
    //   moment(myDate.setDate(myDate.getDate() - 7)).format("YYYY-MM-DD HH:mm:ss")
    // );
    // tmpArr.push(moment(new Date().valueOf()).format("YYYY-MM-DD HH:mm:ss"));
    // this.bedata = tmpArr;
    // this.queryParam.createBeginTime = this.bedata[0];
    // this.queryParam.createEndTime = this.bedata[1];
    this.getDataList()
    this.getaddressstreetlist()
  },
};
</script>
<style lang="less" scoped>
.exportSelectBox {
  display: inline-block;
  margin-left: 10px;
  /deep/.el-input input {
    background: #409eff;
    color: white;
    width: 70px;
    height: 28px;
  }
}
.userList {
  padding: 18px;
  .search_wrap {
    margin-top: 20px;
  }
  .table_div {
    margin-top: 20px;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
